import * as THREE from 'three';
import { FBXLoader } from 'three/addons/loaders/FBXLoader.js';

export async function fbx_file_loader(url: string): Promise<THREE.Group> {
  const fbx_loader = new FBXLoader();

  return new Promise((resolve, reject) => {
    function onLoad(data: any) {
      resolve(data);
    }

    function onError(err: any) {
      reject(err);
    }

    // load a resource
    fbx_loader.load(
      url, // resource URL
      onLoad, // called when resource is loaded
      undefined, // called when loading is in progresses
      onError, // called when loading has errors
    );
  });
}
